import { render, staticRenderFns } from "./AdmissionNote.vue?vue&type=template&id=a126f7b8&scoped=true"
import script from "./AdmissionNote.vue?vue&type=script&lang=js"
export * from "./AdmissionNote.vue?vue&type=script&lang=js"
import style0 from "./AdmissionNote.vue?vue&type=style&index=0&id=a126f7b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a126f7b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a126f7b8')) {
      api.createRecord('a126f7b8', component.options)
    } else {
      api.reload('a126f7b8', component.options)
    }
    module.hot.accept("./AdmissionNote.vue?vue&type=template&id=a126f7b8&scoped=true", function () {
      api.rerender('a126f7b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/AdmissionNote.vue"
export default component.exports